import React, { useState } from "react";
import axios from "axios";
import CostAlertModal from "./CostAlertModal";
import { fetchCancellationAlert, costAlertFromError } from "./cancellationAlert";

/**
 * The Cancel action on the employee bookings page. Shows the cancellation cost
 * alert when the cancellation may cost money, and the page's usual "Are you
 * sure?" confirmation otherwise (CU-86cbawn2a). Reloads the page once cancelled.
 *
 * @param {number} tripId the trip to cancel
 * @param {string} className classes for the link, matching the menu's other items
 * @returns {JSX.Element} the cancel link and its modal
 */
const CancelTripLink = ({ tripId, className }) => {
  const [costAlert, setCostAlert] = useState(null);
  const [loading, setLoading] = useState(false);

  const cancelTrip = (acknowledgedAlert) => {
    setLoading(true);
    axios
      .delete(`/trips/${tripId}`, {
        params: { acknowledged_alert: acknowledgedAlert },
        headers: { Accept: "application/json" },
      })
      .then(() => window.location.reload())
      .catch((error) => {
        setLoading(false);
        // Refused because the cost alert must be confirmed first (or it escalated): show it
        const requiredAlert = costAlertFromError(error);
        if (requiredAlert) {
          setCostAlert(requiredAlert);
          return;
        }
        window.alert("The trip could not be cancelled. Please try again.");
      });
  };

  const handleClick = () => {
    void fetchCancellationAlert([tripId]).then((alert) => {
      if (alert) {
        setCostAlert(alert);
      } else if (window.confirm("Are you sure?")) {
        cancelTrip(null);
      }
    });
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={`${className} w-full text-left`}
        data-testid="employee-bookings-cancel-trip"
      >
        Cancel
      </button>
      <CostAlertModal
        alert={costAlert}
        loading={loading}
        onDismiss={() => setCostAlert(null)}
        onConfirm={() => cancelTrip(costAlert)}
      />
    </>
  );
};

export default CancelTripLink;
